/* eslint-disable react/no-array-index-key */

import React from 'react';

import Carousel from 'react-bootstrap/Carousel';
import { CatalogObjectDisplayObject } from '../../../../Data/CatalogObjectDisplayObject';
import { URLPaths } from '../../../../Util/URLPaths';

type DynamicItemComponentParameters =
{
  item : CatalogObjectDisplayObject,
  showPage : (collectionName: string, objectName: string, pageType: string) => void,
  pageType : string,
  noContentText : string | undefined,
};

export function DynamicItemComponent(
  {
    item,
    showPage,
    pageType,
    noContentText,
  } : DynamicItemComponentParameters,
) {

  const getCarouselItems = () => {
    return (
      <Carousel controls={false}>
        {item.imageURL.map((ref, index) => (
          <Carousel.Item key={index}>
            <button
              type="button"
              style={{
                border: 'none',
                backgroundColor: 'transparent',
                padding: '0px',
              }}
              onClick={() => {
                showPage(item.collectionName, item.name, pageType);
              }}
            >
              <img
                className="d-block w-100"
                src={URLPaths.adjustPathToWeb(ref)}
                style={{ height: '200px', width: '250px', objectFit: 'contain' }}
                alt={`Sample object for collection ${item.collectionName}`}
              />
            </button>
          </Carousel.Item>
        ))}
      </Carousel>
    );
  };

  const getNoContentPlaceHolder = () => {
    return (
      <Carousel controls={false} indicators={false}>
        <Carousel.Item key={1}>
          <button
            type="button"
            style={{
              border: 'none',
              backgroundColor: 'transparent',
              height: '250px',
            }}
            onClick={() => {
              showPage(item.collectionName, item.name, pageType);
            }}
          >
            {noContentText}
          </button>
        </Carousel.Item>
      </Carousel>
    );
  };

  const getContents = () => {
    if (item.imageURL.length > 0) {
      return getCarouselItems();
    }
    return getNoContentPlaceHolder();
  };

  // const itemLine = item.price !== '' ? `${item.name}  -  ${item.price} €` : `${item.name}`;
  const itemLine = `${item.name}`;

  return (
    <div className="dynamic-item" style={{ maxWidth: '250px' }}>
      {getContents()}
      <h4 style={{ textAlign: 'center' }}>
        {itemLine}
      </h4>
    </div>
  );
}
